// removed by extract-text-webpack-plugin
module.exports = {"Cell":"Cell__Cell__2DKIk","CellHeading":"Cell__CellHeading__2j7wL","CellNormal":"Cell__CellNormal__2Kp6F","CellDisabled":"Cell__CellDisabled__23hU0","CellIdentical":"Cell__CellIdentical__3Z2dr","CellDesktopOnly":"Cell__CellDesktopOnly__3GAu0","ArrowIcon":"Cell__ArrowIcon__1AK0V","MoreIcon":"Cell__MoreIcon__3SIdS","CellLabel":"Cell__CellLabel__1qy4N","DropdownClass":"Cell__DropdownClass__3uvMa","ButtonDropdown":"Cell__ButtonDropdown__2xGWd"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Cell/Cell.css
// module id = 365
// module chunks = 0